import React, { useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import CircularProgress from "@mui/material/CircularProgress";
import { FiEdit } from "react-icons/fi";
import profile from "../assets/images/userprofile/profile.png";
import { MatchEditProfile } from "./matchmakerEditprofile/matchEditProfile";
import { MatchProfileUpload } from "./matchmakerProfleUpload/matchProfileupload";
import { MatchmakerAddProfile } from "./matchmakerAddprofle/matchmakerAdd";
import { BeauticianAdd } from "./beauticianAddprofile/beauticianAdd";
import { BeauticianEditProfile } from "./beauticianEditprofile/beauticianEditProfile";
import imagePlaceholder from "../assets/images/userprofile/imagePlaceholder.jpg";
import imagePlaceholder1 from "../assets/images/userprofile/logo_nathi_profile_log99.png";
import { axiosInstance_agent } from "../axiosInstance-agent";
import { Link, useNavigate } from "react-router-dom";
import { MdOutlineDeleteOutline } from "react-icons/md";
import Modal from "react-bootstrap/Modal";
import { ToastContainer, toast } from "react-toastify";
import Preloader from "../Components/Preloader";

const columns = [
  { id: "userid", label: "User ID", minWidth: 170, align: "center" },
  { id: "name", label: "Name", minWidth: 100, align: "center" },
  {
    id: "mobile",
    label: "Mobile",
    minWidth: 170,
    align: "center",
  },
  {
    id: "email",
    label: "Email",
    minWidth: 170,
    align: "center",
  },
  {
    id: "actions",
    label: "Actions",
    minWidth: 170,
    align: "center",
  },
];

function createData(profileImg, userid, name, mobile, email) {
  return { profileImg, userid, name, mobile, email, actions: <FiEdit /> };
}

export function Beauticians() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [userData, setuserData] = useState();
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [deleteId, setDeleteId] = useState();
  const navigate = useNavigate();
  //delete modal state
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = (id) => {
    setShow(true);
    setDeleteId(id);
  };

  // const handleuserData = (query = "") => {
  //   setLoading(true);
  //   axiosInstance_agent
  //     .get(`/beautician?search=${query}`)
  //     .then((response) => {
  //       const users = response.data?.data || [];
  //       setuserData(users);
  //       setLoading(false);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching users:", error);
  //       setLoading(false);
  //     });
  // };

  // useEffect(() => {
  //   handleuserData();
  // }, []);

  // Trigger API call when searchQuery changes (debounced)
  // useEffect(() => {
  //   const delayDebounce = setTimeout(() => {
  //     handleuserData(searchQuery);
  //   }, 100);

  //   return () => clearTimeout(delayDebounce);
  // }, [searchQuery]);
  async function handleUserData() {
    try {
      setLoading(true);
      const response = await axiosInstance_agent.get("/beautician");
      const users = response.data?.data || [];
      setuserData(users);
    } catch (error) {
      console.error("Error fetching Beauticians:", error);
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    handleUserData();
  }, []);
  function handleSearch(e) {
    const value = e.target.value;
    setSearchQuery(value);
  }
  async function FetchSearchDetails() {
    const config = {
      params: {
        search: searchQuery,
      },
    };
    try {
      setLoading(true);
      const response = await axiosInstance_agent.get("/beautician", config);
      if (response.status === 200 || response.data.status === "success") {
        setuserData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching Beauticians:", error);
      // toast.error("Unable to fetch contact lists");
    } finally {
      setLoading(false);
    }
  }

  function handleReset() {
    setSearchQuery("");
    handleUserData();
  }
  async function handleDeleteUser(id) {
    try {
      setLoading(true);
      const response = await axiosInstance_agent.delete(`/photographer/${id}`);
      if (response.data.status === true || response.status === 200) {
        console.log("response", response.data);
        toast.success(response.data.message || "profile deleted successfully!");
        handleUserData();
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to delete!");
      console.log("Failed to fetch users");
    } finally {
      setLoading(false);
    }
  }
  const rows =
    userData?.map((user) => ({
      userid: user?.id ? `XXX${String(user.id).slice(-1)}` : "--",
      originalId: user?.id,
      // profileImg: user.profile?.profile || imagePlaceholder1,
      profileImg: user.profile_pic || imagePlaceholder1,
      name: user.full_name || "--",
      mobile: user.mobile || "--",
      email: user.email || "--",
    })) || [];

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <>
      {loading && <Preloader />}
      <ToastContainer />
      <div className="userProfile-container">
        <div className="userProfile-content">
          <div className="userProfile-title">
            Total User’s : {userData?.length || 0}
          </div>
          <div className="search-container">
            <div className="searchBar">
              <span>
                <input
                  type="text"
                  placeholder="Search by name or email or mobile No."
                  value={searchQuery}
                  onChange={handleSearch}
                />
              </span>
              <div>
                <span
                  className="bi bi-search search me-2"
                  style={{ cursor: "pointer" }}
                  onClick={() => FetchSearchDetails()}
                ></span>
                <span
                  style={{ color: "#F24464", cursor: "pointer" }}
                  onClick={() => handleReset()}
                >
                  Reset
                </span>
              </div>
            </div>
          </div>
          <div>
            <Link to="/beautician-add-profile">
              <button className="btnAdd">+ Add Profile</button>
            </Link>
          </div>
        </div>
        {/* table data */}
        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <TableContainer sx={{ maxHeight: 440 }} className="table-container">
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                      className="table-header"
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      <CircularProgress style={{ color: "#f24464" }} />
                    </TableCell>
                  </TableRow>
                ) : rows.length > 0 ? (
                  rows
                    // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={row.userid}
                      >
                        {columns.map((column) => {
                          const value = row[column.id];
                          return (
                            <TableCell
                              key={column.id}
                              align={column.align}
                              className="tableCelldata"
                            >
                              {column.id === "userid" ? (
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                  }}
                                >
                                  <img
                                    src={row.profileImg}
                                    alt="profile"
                                    onError={(e) => {
                                      e.target.onerror = null; // Prevent infinite loop
                                      e.target.src = imagePlaceholder1;
                                    }}
                                    style={{
                                      width: 40,
                                      height: 40,
                                      borderRadius: "10px",
                                    }}
                                  />
                                  <span>{row.userid}</span>
                                </div>
                              ) : column.id === "actions" ? (
                                <div>
                                  <FiEdit
                                    style={{ cursor: "pointer" }}
                                    // onClick={() => {
                                    //   if (typeof onContentChange === "function") {
                                    //     onContentChange(() => (
                                    //       <BeauticianEditProfile
                                    //         onContentChange={onContentChange}
                                    //         userId={row.originalId}
                                    //       />
                                    //     ));
                                    //   }
                                    // }}

                                    onClick={() =>
                                      navigate("/beautician-edit", {
                                        state: { id: row.originalId },
                                      })
                                    }
                                  />
                                  <MdOutlineDeleteOutline
                                    className="ms-3"
                                    onClick={() => handleShow(row.originalId)}
                                  />
                                </div>
                              ) : (
                                value
                              )}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      No data available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          {/* <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        /> */}
        </Paper>
        {/* delete modal  */}
        <div>
          <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton style={{ borderBottom: "none" }}>
              {/* <Modal.Title>Delete</Modal.Title> */}
            </Modal.Header>
            <Modal.Body className="deleteText">
              Are you sure want to delete?
            </Modal.Body>
            <Modal.Footer style={{ borderTop: "none" }}>
              <button
                variant="secondary"
                onClick={handleClose}
                className="deleteModalBtnCancel"
              >
                Cancel
              </button>
              <button
                variant="primary"
                onClick={() => {
                  handleClose();
                  handleDeleteUser(deleteId);
                }}
                className="deleteModalBtnDelete"
              >
                Delete
              </button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </>
  );
}
